(() => {
  if (window.__msCanadaTariffInit) return;
  window.__msCanadaTariffInit = true;

  const RATE = 0.05;
  const ACK_RE = /acknowledge[\s\S]*?(?:5|10|12\.5)%[\s\S]*?(?:import|canada)\s+surcharge/i;
  const TAGS = new Set(['mobital', 'huppe', 'trica', 'ms-import-surcharge-12_5']);
  const cfg = window.__msCanadaTariff || {};
  const MAX_WAIT_MS = 60000;

  const money = (cents) => {
    const amount = (Number(cents) || 0) / 100;
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        const fmt = cfg.moneyFormat || Shopify.money_format || '${{amount}}';
        return Shopify.formatMoney(Math.round(amount * 100), fmt);
      }
    } catch (_) {}
    return amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  };

  const productId = () => {
    if (cfg.productId) return String(cfg.productId);
    const root = document.querySelector('[data-section-type="product"][data-product-id]');
    if (root) return String(root.getAttribute('data-product-id'));
    const meta =
      (window.meta && window.meta.product) ||
      (window.ShopifyAnalytics &&
        ShopifyAnalytics.meta &&
        ShopifyAnalytics.meta.product);
    return meta && meta.id ? String(meta.id) : '';
  };

  const hasEligibleTag = () => {
    if ((cfg.tags || []).map((t) => String(t).toLowerCase()).some((t) => TAGS.has(t))) {
      return true;
    }
    const root = document.querySelector('[data-section-type="product"]');
    const attr =
      (root && (root.getAttribute('data-product-tags') || root.dataset.productTags)) || '';
    return String(attr)
      .split(',')
      .map((t) => t.trim().toLowerCase())
      .some((t) => TAGS.has(t));
  };

  const strings = cfg.strings || {};
  const brand = String(cfg.brand || '').trim();
  const ackText = strings.acknowledge || 'I acknowledge the 5% Canada surcharge';

  const checkboxText = (input) => {
    const label = document.querySelector('label[for="' + input.id + '"]') || input.closest('label');
    return ((label && label.textContent) || input.value || '').trim();
  };

  const findAckCheckbox = (pid) => {
    const appInputs = document.querySelectorAll('#bcpo input[type="checkbox"], .ms-tariff-ack-slot input[type="checkbox"]:not([data-ms-tariff-fallback])');
    for (const input of appInputs) {
      if (ACK_RE.test(checkboxText(input)) || ACK_RE.test(input.value || '')) return input;
    }
    return document.querySelector('input[data-ms-tariff-fallback]');
  };

  const brandAck = (checkbox) => {
    if (!checkbox) return;
    const fallback = document.querySelector('input[data-ms-tariff-fallback]');
    if (fallback && fallback !== checkbox) {
      if (fallback.checked) checkbox.checked = true;
      fallback.closest('[data-ms-tariff-fallback-wrap]').remove();
    }
    const label = document.querySelector('label[for="' + checkbox.id + '"]') || checkbox.closest('label');
    const heading = checkbox.closest('.selector-wrapper')?.querySelector('.bcpo-title');
    if (heading && /(?:Canada\s+Tariff|(?:\S+\s+)?Import\s+surcharge|Canada\s+surcharge)\s*[—–-]\s*(?:5|10|12\.5)%/i.test(heading.textContent || '')) {
      const headingText = (strings.line || 'Canada surcharge — 5%') + ':';
      if (heading.textContent !== headingText) heading.textContent = headingText;
    }
    if (label && label.dataset.msTariffBrand !== brand) {
      const textNodes = [];
      const walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) textNodes.push(walker.currentNode);
      const target = textNodes.find((node) => ACK_RE.test(node.textContent || ''));
      if (target) target.textContent = ackText;
      label.dataset.msTariffBrand = brand;
    }
    if (ACK_RE.test(checkbox.value || '')) checkbox.value = ackText;
    if (/^properties\[(?:Canada\s+Tariff|Import\s+surcharge(?:\s+acknowledgement)?)[^\]]*\](?:\[\])?$/i.test(checkbox.name || '')) {
      checkbox.name = checkbox.name.replace(/^properties\[[^\]]*\]/, 'properties[' + (strings.line || 'Canada surcharge — 5%') + ']');
    }
    checkbox.required = true;
  };

  const ensureAckCheckbox = (root, pid) => {
    const existing = findAckCheckbox(pid);
    if (existing) { brandAck(existing); return existing; }
    const button = root.querySelector('[data-add-to-cart], button[name="add"], .add-to-cart');
    const form = button && (button.form || button.closest('form'));
    const anchor = button && (button.closest('.product-block') || form || button.parentElement);
    if (!form || !anchor || !anchor.parentNode) return null;
    const wrap = document.createElement('div');
    wrap.className = 'selector-wrapper bcpo-checkboxes';
    wrap.setAttribute('data-ms-tariff-fallback-wrap', '1');
    const label = document.createElement('label');
    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.id = 'ms-import-ack-' + pid;
    checkbox.name = 'properties[' + (strings.line || 'Canada surcharge — 5%') + ']';
    checkbox.value = ackText;
    checkbox.required = true;
    checkbox.setAttribute('data-ms-tariff-fallback', '1');
    const formId = form.getAttribute('id');
    if (formId) checkbox.setAttribute('form', formId);
    label.htmlFor = checkbox.id;
    label.appendChild(checkbox);
    label.appendChild(document.createTextNode(ackText));
    wrap.appendChild(label);
    anchor.parentNode.insertBefore(wrap, anchor);
    return checkbox;
  };

  const brandPanel = (panel) => {
    if (!panel) return;
    panel.querySelector('.ms-tariff-total__title').textContent = strings.title || 'Estimated total with Canada surcharge';
    const labels = panel.querySelectorAll('.ms-tariff-total__label');
    labels[0].textContent = strings.subtotal || 'Product subtotal';
    labels[1].textContent = strings.line || 'Canada surcharge — 5%';
    labels[2].textContent = strings.total || 'Estimated total';
    panel.querySelector('.ms-tariff-total__note').textContent = strings.note || 'Shipping and tax are separate.';
  };

  const guardAck = (event) => {
    const pid = productId();
    const root = productRoot(pid);
    const target = event.target instanceof Element ? event.target : null;
    const button = target && target.closest('[data-add-to-cart], button[name="add"], .add-to-cart');
    const form = target && target.closest('form[action*="/cart/add"]');
    if (event.type === 'click' && (!button || !root.contains(button))) return;
    if (event.type === 'submit' && (!form || !root.contains(form))) return;
    const checkbox = ensureAckCheckbox(root, pid);
    if (!checkbox || checkbox.checked) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkbox.setCustomValidity(strings.required || 'Please acknowledge the import surcharge.');
    checkbox.focus();
    checkbox.reportValidity();
  };


  const getQty = (root, pid) => {
    const formSuffix = pid ? '[form$="-' + pid + '"]' : '';
    const input =
      (root && root.querySelector('input[name="quantity"]' + formSuffix)) ||
      document.querySelector('input[name="quantity"]' + formSuffix) ||
      document.querySelector('input[name="quantity"]');
    const n = parseInt(input && input.value, 10);
    return Number.isFinite(n) && n > 0 ? n : 1;
  };

  const selectedVariantId = (root) => {
    const scope = root || document;
    const idInput = scope.querySelector(
      'form[action*="/cart/add"] select[name="id"], form[action*="/cart/add"] input[name="id"]'
    );
    return idInput && idInput.value ? String(idInput.value) : null;
  };

  const variantUnitCents = (root, pid) => {
    // Options apps may use a generated cart variant. Their displayed USD price
    // includes the selected paid configuration and is the estimate's source.
    const price = root.querySelector('[data-product-price]');
    const usd = price && price.getAttribute('data-usd');
    if (usd) {
      const amount = Number(usd.replace(/[^0-9.-]/g, ''));
      if (Number.isFinite(amount) && amount >= 0) return Math.round(amount * 100);
    }
    const variants = cfg.variants || [];
    const vid = selectedVariantId(root);
    if (vid) {
      const match = variants.find((v) => String(v.id) === String(vid));
      if (match && typeof match.price === 'number') return match.price;
    }
    try {
      const ta = root && root.querySelector('[data-current-variant-json]');
      if (ta && ta.textContent) {
        const v = JSON.parse(ta.textContent.trim());
        if (v && typeof v.price === 'number') return v.price;
      }
    } catch (_) {}
    if (variants[0] && typeof variants[0].price === 'number') return variants[0].price;
    if (window.bcpo_product && typeof bcpo_product.price === 'number') return bcpo_product.price;
    return 0;
  };

  const ensurePanel = (anchor) => {
    let panel = document.querySelector('.ms-tariff-total');
    if (panel) { brandPanel(panel); return panel; }
    panel = document.createElement('div');
    panel.className = 'ms-tariff-total';
    panel.setAttribute('data-ms-tariff-total', '1');
    panel.setAttribute('aria-live', 'polite');
    panel.setAttribute('aria-hidden', 'true');
    panel.innerHTML =
      '<div class="ms-tariff-total__clip">' +
      '<div class="ms-tariff-total__inner">' +
      '<div class="ms-tariff-total__title">Estimated total with Canada surcharge</div>' +
      '<div class="ms-tariff-total__row">' +
      '<span class="ms-tariff-total__label">Product subtotal</span>' +
      '<span class="ms-tariff-total__value" data-ms-tariff-subtotal>—</span>' +
      '</div>' +
      '<div class="ms-tariff-total__row">' +
      '<span class="ms-tariff-total__label">Canada surcharge — 5%</span>' +
      '<span class="ms-tariff-total__value" data-ms-tariff-surcharge>—</span>' +
      '</div>' +
      '<div class="ms-tariff-total__row ms-tariff-total__row--total">' +
      '<span class="ms-tariff-total__label">Estimated total</span>' +
      '<span class="ms-tariff-total__value" data-ms-tariff-grand>—</span>' +
      '</div>' +
      '<p class="ms-tariff-total__note">Surcharge is applied at checkout for eligible items. Shipping and tax are separate.</p>' +
      '</div></div>';
    brandPanel(panel);
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(panel, anchor.nextSibling);
    } else {
      document.body.appendChild(panel);
    }
    return panel;
  };

  const setOpen = (panel, checkbox) => {
    const open = !!(checkbox && checkbox.checked);
    panel.classList.toggle('is-acked', open);
    panel.classList.toggle('is-open', open);
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
  };

  const update = (root, checkbox, panel, pid) => {
    if (!panel) return;
    const qty = getQty(root, pid);
    const unit = variantUnitCents(root, pid);
    const hasQuotedPrice = Number.isFinite(unit) && unit > 0;
    panel.hidden = !hasQuotedPrice;
    if (!hasQuotedPrice) {
      panel.style.display = 'none';
      panel.querySelectorAll('[data-ms-tariff-subtotal], [data-ms-tariff-surcharge], [data-ms-tariff-grand]').forEach((value) => {
        value.textContent = '—';
      });
      setOpen(panel, null);
      return;
    }
    panel.style.removeProperty('display');
    const subtotal = Math.round(unit * qty);
    const surcharge = Math.round(subtotal * RATE);
    const total = subtotal + surcharge;
    const subEl = panel.querySelector('[data-ms-tariff-subtotal]');
    const surEl = panel.querySelector('[data-ms-tariff-surcharge]');
    const totEl = panel.querySelector('[data-ms-tariff-grand]');
    if (subEl) subEl.textContent = money(subtotal);
    if (surEl) surEl.textContent = money(surcharge);
    if (totEl) totEl.textContent = money(total);
    setOpen(panel, checkbox);
  };

  const findQtyBlock = (root, pid) => {
    const quantity =
      (root && root.querySelector('input[name="quantity"][form$="-' + pid + '"]')) ||
      document.querySelector('input[name="quantity"][form$="-' + pid + '"]') ||
      (root && root.querySelector('input[name="quantity"]')) ||
      document.querySelector('input[name="quantity"]');
    return quantity ? quantity.closest('.product-block') || quantity.closest('.product__quantity') : null;
  };

  const findAtcBlock = (root, pid) => {
    const btn =
      (root && root.querySelector('[data-add-to-cart], button[name="add"], .add-to-cart')) ||
      document.querySelector('[data-add-to-cart], button[name="add"], .add-to-cart');
    if (!btn) return null;
    return btn.closest('.product-block') || btn.closest('form') || btn.parentElement;
  };

  const ackWrapper = (checkbox) => {
    if (!checkbox) return null;
    const field = checkbox.closest('.bcpo-checkboxes');
    if (!field) return null;
    // Prefer the option wrapper so title/label moves with it when present
    return (
      field.closest('.selector-wrapper') ||
      field.closest('.bcpo-option') ||
      field.closest('[class*="bcpo"]') ||
      field.parentElement ||
      field
    );
  };

  const isMobicanPdp = () =>
    (cfg.tags || []).some((t) => /^mobican$/i.test(String(t).trim()));

  // Desired order: Quantity → Set Items (if any) → Ack → (Estimated total) → Add to cart
  const placeNearAtc = (root, checkbox, pid) => {
    if (!checkbox) return false;
    const wrap = ackWrapper(checkbox);
    const qtyBlock = findQtyBlock(root, pid);
    const atcBlock = findAtcBlock(root, pid);
    const setEl =
      (root && root.querySelector('[data-ms-set-items], .ms-set-items-block')) ||
      document.querySelector('[data-ms-set-items], .ms-set-items-block') ||
      (root && root.querySelector('.river-set')) ||
      document.querySelector('.river-set');
    const setAnchor = setEl ? (setEl.closest('.product-block') || setEl) : null;
    if (!wrap || !qtyBlock || !atcBlock || !qtyBlock.parentNode) return false;

    if (pid === '6574003486799' && qtyBlock.parentNode !== atcBlock.parentNode) {
      atcBlock.parentNode.insertBefore(qtyBlock, atcBlock);
    }

    let slot = document.querySelector('.ms-tariff-ack-slot');
    if (!slot) {
      slot = document.createElement('div');
      slot.className = 'ms-tariff-ack-slot';
    }

    const anchor = setAnchor || qtyBlock;
    if (anchor.parentNode && anchor.nextElementSibling !== slot) {
      anchor.parentNode.insertBefore(slot, anchor.nextSibling);
    }
    if (slot.nextElementSibling !== atcBlock && atcBlock.parentNode) {
      if (atcBlock.parentNode === anchor.parentNode) {
        if (slot.nextElementSibling !== atcBlock) {
          atcBlock.parentNode.insertBefore(slot, atcBlock);
          if (anchor.nextElementSibling !== slot) {
            slot.parentNode.insertBefore(anchor, slot);
          }
        }
      } else {
        atcBlock.parentNode.insertBefore(slot, atcBlock);
      }
    }

    if (wrap.parentNode !== slot) {
      slot.appendChild(wrap);
    }

    document.querySelectorAll('#bcpo .selector-wrapper, #bcpo .bcpo-option').forEach((el) => {
      if (el.contains(checkbox)) return;
      const t = (el.textContent || '').trim();
      if (/^Canada Tariff/i.test(t) && !el.querySelector('input')) {
        el.style.display = 'none';
      }
    });

    qtyBlock.classList.add('ms-tariff-quantity');

    // Mobican only: "Complete the collection" sits directly above the ack (after the BCPO options),
    // matching the FYSIK stack (Set Items → tariff ack → Add to cart). Other brands unchanged.
    if (setAnchor && isMobicanPdp() && slot.parentNode) {
      const host =
        slot.parentNode !== atcBlock && slot.parentNode.contains(atcBlock) && slot.parentNode.classList.contains('product-block')
          ? slot.parentNode
          : slot;
      if (host.parentNode && host.previousElementSibling !== setAnchor) {
        host.parentNode.insertBefore(setAnchor, host);
      }
      setAnchor.classList.add('ms-set-above-ack');
    }
    return true;
  };

  const productRoot = (pid) =>
    document.querySelector('[data-product-id="' + pid + '"][data-section-type="product"]') ||
    document.querySelector('[data-section-type="product"]') ||
    document;

  let booted = false;
  let observer = null;
  const startedAt = Date.now();

  const wire = (root, checkbox, panel, pid) => {
    const refresh = () => {
      const cb = findAckCheckbox(pid) || checkbox;
      brandAck(cb);
      cb.setCustomValidity('');
      placeNearAtc(root, cb, pid);
      const p = document.querySelector('.ms-tariff-total') || ensurePanel(document.querySelector('.ms-tariff-ack-slot') || cb);
      // Keep panel directly under ack slot
      const slot = document.querySelector('.ms-tariff-ack-slot');
      if (slot && p && p.previousElementSibling !== slot && slot.parentNode) {
        slot.parentNode.insertBefore(p, slot.nextSibling);
      }
      update(root, cb, p, pid);
    };
    document.addEventListener('change', (e) => {
      const t = e.target;
      if (
        t &&
        t.matches &&
        (t.matches('input[name="quantity"]') ||
          t.matches('input[type="checkbox"]') ||
          t.matches('[name="id"]') ||
          t.matches('select'))
      ) {
        refresh();
      }
    });
    document.addEventListener('input', (e) => {
      const t = e.target;
      if (t && t.matches && t.matches('input[name="quantity"]')) refresh();
    });
    document.addEventListener('click', (e) => {
      const t = e.target;
      if (t && t.closest && t.closest('.js-qty__adjust')) setTimeout(refresh, 0);
    });
    document.addEventListener('variant:change', refresh);
    document.addEventListener('theme:variant:change', refresh);
    document.addEventListener('kit:variant-picker:after-change', () => requestAnimationFrame(refresh));
    {
      const price = root.querySelector('[data-product-price]');
      if (price) {
        let pending = false;
        const priceObserver = new MutationObserver(() => {
          if (pending) return;
          pending = true;
          requestAnimationFrame(() => {
            pending = false;
            refresh();
          });
        });
        priceObserver.observe(price.parentElement || price, {
          childList: true,
          characterData: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['data-usd']
        });
      }
    }
  };

  const boot = () => {
    if (booted) return true;
    if (!hasEligibleTag()) return false;
    const pid = productId();
    const root = productRoot(pid);
    const checkbox = ensureAckCheckbox(root, pid);
    if (!checkbox) return false;
    placeNearAtc(root, checkbox, pid);
    const slot = document.querySelector('.ms-tariff-ack-slot');
    const panel = ensurePanel(slot || checkbox);
    if (slot && panel.parentNode !== slot.parentNode) {
      slot.parentNode.insertBefore(panel, slot.nextSibling);
    }
    update(root, checkbox, panel, pid);
    wire(root, checkbox, panel, pid);
    booted = true;
    return true;
  };

  const tick = () => {
    if (booted) {
      const pid = productId();
      const fallback = document.querySelector('input[data-ms-tariff-fallback]');
      const checkbox = findAckCheckbox(pid);
      if (fallback && checkbox && fallback !== checkbox) {
        brandAck(checkbox);
        const root = productRoot(pid);
        placeNearAtc(root, checkbox, pid);
        update(root, checkbox, document.querySelector('.ms-tariff-total'), pid);
      }
      return;
    }
    if (boot()) {
      if (observer) observer.disconnect();
      return;
    }
    if (Date.now() - startedAt > MAX_WAIT_MS) {
      if (observer) observer.disconnect();
    }
  };

  const begin = () => {
    tick();
    observer = new MutationObserver(tick);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => {
      if (observer) observer.disconnect();
      tick();
    }, MAX_WAIT_MS);
    const iv = setInterval(() => {
      if ((booted && !document.querySelector('input[data-ms-tariff-fallback]')) || Date.now() - startedAt > MAX_WAIT_MS) {
        clearInterval(iv);
        return;
      }
      tick();
    }, 500);
  };

  window.addEventListener('click', guardAck, true);
  window.addEventListener('submit', guardAck, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', begin);
  } else {
    begin();
  }
})();
